export function eventManager(fn, timeout=15000){
  let excecuting = false;
  return async () => {
      if(!excecuting){
          excecuting = true;
          await fn();
          setTimeout(() => {excecuting = false}, timeout);
      }
  }
}